<template>
    <v-table :data="tableData" class="main-table__wrapper">
        <thead slot="head" class="main-table__header">
        <th v-for="(tableTitle, key) in tableTitles" class="main-table__header-item">{{tableTitle.title}}</th>
        </thead>
        <tbody slot="body" slot-scope="{displayData}" class="main-table__body">
        <tr v-for="(row, rowIndex) in displayData" :key="row.rowId" class="main-table__row-container">
            <td class="main-table__row-item" v-for="(subRow, subRowIndex) in Object.keys(row)" v-if="subRow !== 'rowId'"
                :class="{
                'main-table__row-item_color_red': row[subRow] === 'REMOVED' || row[subRow] === 'Disabled',
                'main-table__row-item_color_blue': row[subRow] === 'Enabled' || (subRow === 'treshold_rule' && row[subRow] !== 'Disabled')
                }">
                {{parseTableValue(row[subRow])}}
                <inline-svg v-if="subRow === 'is_banned' && row[subRow]"
                            class="main-table__check-icon"
                            src="/images/checked_green.svg" aria-label="PPCShield">
                </inline-svg>
                <inline-svg v-if="subRow === 'vpn_blocking' || subRow === 'treshold_rule'"
                            class="main-table__edit-icon"
                            src="/images/checked_green.svg" aria-label="PPCShield">
                </inline-svg>
            </td>
        </tr>
        </tbody>
    </v-table>
</template>

<script>
    export default {
        name: 'main-table',
        props: ['tableData', 'tableTitles'],
        data: function () {
            return {}
        },
        computed: {},
        methods: {
            parseTableValue(value) {
                return typeof value === 'boolean' ? '' : value;
            },
        },

        mounted() {
        }
    }
</script>
